import axios from "axios";

const state = {
  rawWaitlist: [],
  isLoading: false,
};

const getters = {

};

const mutations = {
  updateLoading (state, isLoading) {
    state.isLoading = isLoading;
  },
  updateWaitlist (state, waitlist) {
    state.rawWaitlist = waitlist;
  },
  updateStatus (state, payload) {
    for (let i = 0; i < state.rawWaitlist.length; i++) {
      if (state.rawWaitlist[i].id == payload.id) {
        state.rawWaitlist[i].status = payload.status.value;
        state.rawWaitlist[i].isLoading = false;
      }
    }
  },
  updateSingleLoading (state, payload) {
    for (let i = 0; i < state.rawWaitlist.length; i++) {
      if (state.rawWaitlist[i].id == payload.id) {
        state.rawWaitlist[i].isLoading = payload.isLoading;
      }
    }
  },
};

const actions = {
  getWaitlist ({ commit }) {
    commit('updateLoading', true);

    axios.get('/api/waitlist/read')
      .then((response) => {
        commit('updateWaitlist', response.data.waitlist);
      })
      .catch(() => {
        // 
      })
      .finally(() => {
        commit('updateLoading', false);
      });
  },
  setStatus ({ commit }, payload) {
    commit('updateSingleLoading', { id: payload.id, isLoading: true });
    axios.post(`/api/waitlist/${payload.id}/save`, { status: payload.status.value })
      .then(() => {
        commit('updateStatus', payload);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
